let tiktokScriptPromise;

export function loadTikTokScript() {
  if (tiktokScriptPromise) return tiktokScriptPromise;

  tiktokScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://www.tiktok.com/embed.js';
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.append(script);
  });

  return tiktokScriptPromise;
}

class EyeRiseTikTokFeed extends HTMLElement {
  connectedCallback() {
    const actions = this.querySelectorAll('[data-tiktok-load]');
    if (!actions.length) return;
    const embeds = this.querySelectorAll('[data-tiktok-embed]');

    const activate = (action) => {
      action.addEventListener('click', () => {
        action.disabled = true;
        loadTikTokScript()
          .then(() => { action.hidden = true; })
          .catch(() => { action.disabled = false; });
      });
    };

    actions.forEach(activate);
    if (!('IntersectionObserver' in window)) {
      actions.forEach((action) => { action.hidden = false; });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        entry.target.parentElement.querySelector('[data-tiktok-load]').hidden = false;
      }
    }, { rootMargin: '600px 0px' });

    embeds.forEach((embed) => observer.observe(embed));
  }
}

if (!customElements.get('eyerise-tiktok-feed')) {
  customElements.define('eyerise-tiktok-feed', EyeRiseTikTokFeed);
}
